import { TODO, UIBModal } from '@b2b/types/core';
import angular, { IScope } from 'angular';

export const TemplatesCreateSchedulesCreateFormsModalsRemoveControllerModule = angular
  .module('acme.view.application.templates.create.schedules.create.forms.modals.remove.controllers', ['ui.bootstrap'])
  .controller('TemplatesCreateSchedulesCreateFormsModalsRemoveController', [
    '$scope',
    '$uibModalInstance',
    function TemplatesCreateSchedulesCreateFormsModalsRemoveController(
      $scope: IScope & { templatesCreateSchedulesCreateFormsModalsRemove: TODO },
      $uibModalInstance: UIBModal<TODO>
    ) {
      $scope.templatesCreateSchedulesCreateFormsModalsRemove = {
        model: '',

        init: function () {},

        done: function () {
          $uibModalInstance.close(undefined);
        },

        cancel: function () {
          $uibModalInstance.dismiss();
        },

        success: {
          init: function (response) {},
        },

        error: {
          init: function (response) {},
        },
      };

      $scope.templatesCreateSchedulesCreateFormsModalsRemove.init();
    },
  ]).name;
